import { EventGA4 } from "./eventGa4.model";

export class KioskPropertiesGa4 extends EventGA4 {

  storefront: string;
  page_location: string;
  page_referrer: string;
  page_title: string; 
  screen_resolution: string;
  language: string;
  kiosk_id: string;
  isSeamless: boolean;

  constructor(data){
    super(data);
    this.event = 'user_properties';
    this.storefront = data?.storefront;
    this.page_location = data?.page_location;
    this.page_title = data?.page_title || 'aeromexico';
    this.page_referrer = data?.page_referrer || 'NA';
    this.screen_resolution = data?.screen_resolution || '1280x1024';
    this.language = data?.language;
    this.kiosk_id = data?.kiosk_id;
    this.isSeamless = data?.isSeamless;
  }
}